<template>
  <v-card flat color="transparent">
    <v-card-text class="py-0">
      <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
        <v-col cols="12" class="pa-0 b-B">
          <v-toolbar flat color="transparent" height="40">
            <v-toolbar-title class="text-left subheading">
              <span class="title">ユーザ</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-sheet class="overflow-y-auto" :style="contentsHeight">
        <v-row class="ma-0 pa-0" align="center">
          <v-col cols="12" class="px-0" align="center">
            <v-row class="ma-0 pa-0" align="center">
              <v-col cols="1" class="pa-0" align="center"></v-col>
              <v-col cols="7" class="pa-0">
                <v-select
                  :items='myGroups'
                  :label="id == 0 ? '教室' : 'グループ'"
                  v-model='group'
                  item-text="name"
                  item-value="key"
                  hideDetails
                  outlined
                  small-chips
                ></v-select>
              </v-col>
              <v-col cols="4" class="py-0" align="center">
                <v-radio-group v-model="id" row>
                  <v-radio label="教室" :value=0 color="primary" @change="group = null"></v-radio>
                  <v-radio label="グループ" :value=1 color="primary" @change="group = null"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <template v-if="id == 0">
          <v-row class="ma-0 pa-0" align="center">
            <v-col cols="1" class="pa-0" align="center"></v-col>
            <v-col cols="11" class="pa-0">
              <v-row class="ma-0 py-0" align="center">
                <v-col cols="12" class="py-0 b-B-GREY-DARK" align="center">
                  <v-row align="center" justify="center" style="height:48px;">
                    <template v-for="(header, index) in heads[id]">
                      <v-col :cols="header.width" :align="header.align" class="pa-0" :key="header.key">
                        <template v-if="header.valid">
                          <v-sheet class="pa-0 customHeader" color="transparent">
                            <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                            <v-icon :color="heads[id][index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                          </v-sheet>
                        </template>
                        <template v-else>
                          <span>{{ header.title }}</span>
                        </template>
                      </v-col>
                    </template>
                    <v-col class="pa-0" align="center">
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="pa-0" align="center">
                  <div class='overflow-y-auto'>
                    <RecycleScroller
                      class="scroller"
                      :items="myUsers"
                      :item-size="44"
                      key-field="key"
                    >
                      <template v-slot="{ item, index }">
                        <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                          <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;" @click.stop="onSelect(item)">
                            <template v-for="(header) in heads[id]">
                              <v-col :cols="header.width" class="pa-0" align="start" :key="header.key">
                                <template v-if="header.key == 'name'">
                                  <v-row class="ma-0 pa-0" align="center">
                                    <v-col cols="2" class="pa-0">
                                      <v-avatar size="30">
                                        <img v-if="item.avatar" :src="item.avatar.thumbnail">
                                        <v-avatar v-else size="30" color="primary"><span class="font-weight-bold white--text" style="font-size:20px; user-select: none;">{{ getNamePrefixFromItem(item) }}</span></v-avatar>
                                      </v-avatar>
                                    </v-col>
                                    <v-col class="pa-0">
                                      <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                                    </v-col>
                                  </v-row>
                                </template>
                                <template v-else-if="header.key == 'enableType'">
                                  <v-chip x-small :color="item.enable ? 'primary' : 'error'"><span >{{ item[header.key] }}</span></v-chip>
                                </template>
                                <template v-else>
                                  <span class="overflow-text-hidden">{{ item[header.key] }}</span>
                                </template>
                              </v-col>
                            </template>
                          </v-row>
                        </v-sheet>
                      </template>
                    </RecycleScroller>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row class="ma-0 pa-0" align="center">
            <v-col cols="1" class="pa-0" align="center"></v-col>
            <v-col cols="11" class="pa-0">
              <template-chats-member
                v-if="group && getChatRef(group)"
                :group="getGroup()"
                :userref="getChatRef(group)"
                :noheader="true"
                background="transparent"
              >
              </template-chats-member>
            </v-col>
          </v-row>
        </template>
      </v-sheet>
    </v-card-text>

    <div>
      <v-dialog
        v-model="dialog"
        persistent
        width="800"
      >
        <v-card v-if="dialog">
          <v-toolbar height="60" dark flat color="error">
            <v-toolbar-title class="white--text pl-2">{{ item.name }}</v-toolbar-title>
          </v-toolbar>
          <template-user
            :item="item"
            :type="getType(item)"
            :mode="'users'"
            :contentsHeight="dialogHeight"
          >
          </template-user>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded depressed @click="onDismissed()">取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-card>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import TemplateUser from './TemplateUser.vue'
import ChatsMemeber from '../../views/chat/ChatsMemberDialog.vue'
Vue.component('template-user', TemplateUser)
Vue.component('template-chats-member', ChatsMemeber)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      chatRef: 'chatRef/chatRef',
      chatRefStatus: 'chatRefStatus/chatRef',
      publicUsers: 'publicUsers/users',
      windowSize: 'shared/windowSize'
    }),
    myGroups () {
      var temp = [
        { key: '*', name: '全教室', avatar: null, classType: 'N/A', publicType: 'N/A', enable: true },
        { key: 'none', name: '未所属', avatar: null, classType: 'N/A', publicType: 'N/A', enable: true }
      ]
      if (this.id === 1 || this.getPrivilegesLevel(this.data) > 1) {
        temp = []
      }
      var payload = null
      if (this.getPrivilegesLevel(this.data) <= 1) {
        for (var i in this.groups) {
          if (this.groups[i].schools[this.mySchool.key] && this.checkId(this.groups[i])) {
            payload = JSON.parse(JSON.stringify(this.groups[i]))
            temp.push(this.getViewData(payload))
          }
        }
      } else {
        var keys = Object.keys(this.data.groups)
        for (i in keys) {
          if (this.data.groups[keys[i]]) {
            var index = this.groups.findIndex(g => g.key === keys[i])
            if (index !== -1 && this.checkId(this.groups[index])) {
              payload = JSON.parse(JSON.stringify(this.groups[index]))
              temp.push(this.getViewData(payload))
            }
          }
        }
        var groups = this.chatRef.filter(function (ref) {
          return ref.type === 'group'
        })
        for (i in groups) {
          index = this.groups.findIndex(g => g.key === groups[i].key)
          if (index !== -1 && this.checkId(this.groups[index])) {
            payload = JSON.parse(JSON.stringify(this.groups[index]))
            temp.push(this.getViewData(payload))
          }
        }
      }
      return temp
    },
    myUsers () {
      var temp = []
      if (this.id === 0) {
        for (var i in this.users) {
          if (this.users[i].schools[this.mySchool.key]) {
            if (this.group === 'none') {
              var keys = Object.keys(this.users[i].groups)
              var check = false
              for (var x in keys) {
                if (this.users[i].groups[keys[x]]) {
                  check = true
                }
              }
              if (!check) {
                temp.push(this.getViewData(JSON.parse(JSON.stringify(this.users[i]))))
              }
            } else if (this.group === '*') {
              temp.push(this.getViewData(JSON.parse(JSON.stringify(this.users[i]))))
            } else if (this.users[i].groups[this.group]) {
              temp.push(this.getViewData(JSON.parse(JSON.stringify(this.users[i]))))
            }
          }
        }
      } else if (this.id === 1) {
        var gindex = this.groups.findIndex(g => g.key === this.group)
        if (gindex !== -1) {
          var index = this.chatRefStatus.findIndex(c => c.key === this.groups[gindex].key)
          if (index !== -1) {
            keys = Object.keys(this.chatRefStatus[index].members)
            for (i in keys) {
              var uidx = this.users.findIndex(u => u.key === keys[i])
              if (uidx !== -1) {
                var payload = JSON.parse(JSON.stringify(this.users[uidx]))
                payload.owner = this.users[uidx].key === this.groups[gindex].owner
                temp.push(this.getViewData(payload))
                continue
              }
              uidx = this.publicUsers.findIndex(u => u.key === keys[i])
              if (uidx !== -1) {
                payload = JSON.parse(JSON.stringify(this.publicUsers[uidx]))
                payload.owner = this.publicUsers[uidx].key === this.groups[gindex].owner
                temp.push(this.getViewData(payload))
              }
            }
          }
        }
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    mySchool () {
      if (this.school) {
        return JSON.parse(JSON.stringify(this.school))
      } else {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            var index = this.schools.findIndex(s => s.key === keys[i])
            if (index !== -1) {
              return JSON.parse(JSON.stringify(this.schools[index]))
            }
          }
        }
      }
      return null
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    },
    dialogHeight () {
      var h = Math.round(this.windowSize.y * 0.6)
      h = h > 700 ? 700 : h
      return 'background: transparent; height: ' + String(h) + 'px;'
    },
    heads () {
      return [ this.headers, this.headers2 ]
    }
  },
  data () {
    return {
      dialog: false,
      group: null,
      id: 0,
      headers: [
        { valid: true, over: false, value: 2, title: '氏名', key: 'name', width: '6', align: 'start' },
        { valid: true, over: false, value: 0, title: '権限', key: 'accessType', width: '2', align: 'start' },
        { valid: true, over: false, value: 0, title: '登録', key: 'createdDate', width: '2', align: 'start' },
        { valid: true, over: false, value: 0, title: '状態', key: 'enableType', width: '2', align: 'start' }
      ],
      headers2: [
        { valid: true, over: false, value: 2, title: '氏名', key: 'name', width: '6', align: 'start' },
        { valid: true, over: false, value: 2, title: '所属', key: 'schoolName', width: '4', align: 'start' },
        { valid: true, over: false, value: 0, title: '状態', key: 'enableType', width: '2', align: 'start' }
      ],
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      loading: false,
      file: null,
      url: null,
      item: null
    }
  },
  watch: {
    users () {
      if (this.item) {
        var index = this.users.findIndex(u => u.key === this.item.key)
        this.item = JSON.parse(JSON.stringify(this.users[index]))
      }
    }
  },
  props: [ 'type', 'school' ],
  methods: {
    checkId (item) {
      if (this.id === 0 && item.classroom) {
        return true
      }
      if (this.id === 1 && !item.classroom) {
        return true
      }
      return false
    },
    getNamePrefixFromItem (item) {
      var name = '？'
      if (item.name) {
        name = item.name.slice(0, 1)
      }
      return name
    },
    getViewData (payload) {
      payload.publicType = payload.public ? '公開' : '非公開'
      payload.accessType = this.gerPrivileges(payload)
      payload.createdDate = moment(payload.createdAt).format('YYYY-MM-DD')
      payload.enableType = payload.enable ? '有効' : '無効'
      payload.schoolName = this.getSchool(payload)
      return payload
    },
    gerPrivileges (user) {
      var index = this.$PRIVILEGES.findIndex(p => p.role === user.role)
      if (index !== -1) {
        return this.$PRIVILEGES[index].name
      }
      return ''
    },
    getProfileImage (item) {
      if (item.avatar) {
        return item.avatar.thumbnail
      }
      return ''
    },
    getSchool (item) {
      var keys = Object.keys(item.schools)
      for (var i in keys) {
        if (item.schools[keys[i]]) {
          const index = this.schools.findIndex(school => school.key === keys[i])
          if (index !== -1) {
            return this.schools[index].name
          }
        }
      }
      return 'N/A'
    },
    getGroup () {
      var index = this.groups.findIndex(g => g.key === this.group)
      if (index !== -1) {
        return this.groups[index]
      }
      return null
    },
    getChatRef (key) {
      var index = this.chatRef.findIndex(ref => ref.key === key)
      if (index !== -1) {
        return this.chatRef[index]
      }
      return null
    },
    getType (item) {
      if (this.data && this.data.role === 'admin') {
        return 'edit'
      }
      if (this.data.schools[item.primary]) {
        return 'edit'
      }
      return 'view'
    },
    onSelect (item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.dialog = true
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    },
    onDismissed () {
      this.dialog = false
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>
img {
  object-fit: cover !important;
}
.scroller {
  height: 100%;
}
.overflow-text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  user-select: none !important;
}

.b-B-GREY {
  border-bottom: 1px solid #EEEEEE80 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.customHeader {
  cursor: pointer;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}
</style>
